module.exports = __webpack_public_path__ + "4a6dcfa93999cbfe74b946b4f3655b32.jpg";